import { history } from '~/store';

import { REDIRECT_ORDER_DRAWER_REQUEST_STORE } from '../constants/redirectOrderDrawerRequestStore.const';
import { REDIRECT_AND_OPEN_ORDER_DRAWER_SCAN_ACTION_NAME } from '../constants/scanActionNames.const';
import { type RedirectOrderDrawerRequestStore } from '../types/redirectOrderDrawerRequest.type';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';
import { resolveDisplayedOrderDetailsOrderId } from '../utils/resolveOrderDetailsPageRoute.util';

interface CreateRedirectAndOpenOrderDrawerScanActionOptions {
  navigate?: (path: string) => void;
  requestStore?: RedirectOrderDrawerRequestStore;
}

const isRedirectAndOpenOrderDrawerMatch = (scanEvent: ScanEvent): boolean => {
  const {
    barcode_content: barcodeContent,
    is_configured_for_scan_to_print,
    route,
  } = scanEvent.scan_context;
  if (!is_configured_for_scan_to_print || !barcodeContent) return false;

  if (route.route === 'shipments') return !barcodeContent.transaction_object_id;
  if (route.route !== 'orders') return true;

  if (route.raw_path === '/orders' || route.raw_path === '/orders/') return false;

  return resolveDisplayedOrderDetailsOrderId(route.raw_path) !== barcodeContent.order_object_id;
};

export const createRedirectAndOpenOrderDrawerScanAction = ({
  navigate = (path) => history.push(path),
  requestStore = REDIRECT_ORDER_DRAWER_REQUEST_STORE,
}: CreateRedirectAndOpenOrderDrawerScanActionOptions = {}): ScanAction => ({
  execute: (scanEvent: ScanEvent): ScanActionResult => {
    const barcodeContent = scanEvent.scan_context.barcode_content;
    if (!barcodeContent) throw new Error('Missing barcode content for redirected order drawer');

    requestStore.set({ barcodeContent, correlationId: scanEvent.correlation_id });

    try {
      navigate('/orders');
    } catch (error) {
      requestStore.reset();
      throw error;
    }

    return { success: true };
  },

  matches: isRedirectAndOpenOrderDrawerMatch,

  name: REDIRECT_AND_OPEN_ORDER_DRAWER_SCAN_ACTION_NAME,
});
